// extracted by mini-css-extract-plugin
module.exports = {"margin":"CvYxUuv4Lo3_EANv1-Mg7","headingCell":"_3XrR51OMj7k9Ta3P6vrA8L","rateCell":"fMFVRJOvLGHCAHelGKEyj"};